// extracted by mini-css-extract-plugin
module.exports = {"l_section":"LayoutSection_l_section__0Htbe"};